import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./styles/index.css";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <Router basename="/lp/dashboard-referral">
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
